<ng-container *ngIf="validationTranslations$ | async as validationTranslations">
  <div class="wrapper">
    <input
      type="text"
      class="form-control"
      [placeholder]="
        selectedItems.length === 0
          ? validationTranslations['ClickToSelectLanguage']
          : ''
      "
      (focus)="inputActive = true"
      (blur)="unsetFocus()"
      readonly
    />
    <div class="badges d-flex">
      <span
        class="badge tag label label-info"
        *ngFor="let selectedItem of selectedItems; trackBy: trackBySelectedFn"
      >
        <span>{{ selectedItem }}</span>
        <a
          ><i
            class="ifc-custom ifc-close"
            (click)="removeItem(selectedItem)"
          ></i
        ></a>
      </span>
    </div>
  </div>
  <div
    class="autocomplete-wrapper"
    *ngIf="availableItems.length && inputActive"
  >
    <div class="autocomplete">
      <button
        *ngFor="let item of availableItems; trackBy: trackByFn"
        (click)="selectItem(item)"
      >
        {{ item }}
      </button>
    </div>
  </div>
  <span *ngIf="!this.isValid" class="text-danger">{{
    validationTranslations['InvalidGroupSize'] + ' ' + sizeString
  }}</span>
</ng-container>
